import type { ReactElement } from 'react'

import { useSession } from '../../auth/useSession'
import { EmptyState, Spinner } from '../../components'
import { OperationsPage } from '../operations/OperationsPage'

/**
 * Where every way into the app lands (`/`): the plant's operations for whoever
 * holds that section — the wall tablet sits here all day — and, for a role with
 * none of this application's screens (`cocina` works in the planner's Tablero),
 * a plain statement instead of a screen that answers FORBIDDEN.
 *
 * The same element and not a redirect to `/operaciones`: a redirect on `/` would
 * rewrite the URL of the screen a wall tablet sits on all day.
 */
export const HomePage = (): ReactElement => {
  const { isLoading, hasSection } = useSession()

  if (isLoading) {
    return <Spinner size="page" label="Cargando tu sesión…" />
  }

  if (hasSection('operaciones')) {
    return <OperationsPage />
  }

  return (
    <EmptyState
      title="Nada que mostrar aquí"
      message="Tu rol no tiene pantallas en esta aplicación. Si crees que debería, pídeselo a quien gestiona los usuarios."
    />
  )
}
